import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GetAnalyticsDashboard} from 'insights/analytics-dashboards/details/graphql/__generated/GetAnalyticsDashboard';
import AnalyticsQuerySettingsModal from 'insights/analytics-queries/settings/AnalyticsQuerySettingsModal';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';
import pickDefined from 'util/pickDefined';

import {AnalyticsQuerySpecRequest} from '../RESTAnalyticsQueryTypes';

type AnalyticsQuery = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>['analyticsQueries'][number];

interface Actions {
  updateAnalyticsQuery: (analyticsQuery: string, querySpecRequest: AnalyticsQuerySpecRequest) => void;
}

export interface AnalyticsQuerySettingsButtonProps {
  actions: Actions;
  analyticsQuery: AnalyticsQuery;
  buttonSize: ButtonSize;
  className?: string;
  tooltipPlacement?: TooltipPlacement;
}

export default function AnalyticsQuerySettingsButton(props: AnalyticsQuerySettingsButtonProps): JSX.Element {
  function handleClick(): void {
    const modalProps = pickDefined(props, 'actions', 'analyticsQuery');
    runModal(AnalyticsQuerySettingsModal, modalProps);
  }

  return (
    <Tooltip title="Block settings" placement={props.tooltipPlacement}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className={props.className}
        icon="settings"
        onClick={handleClick}
        size={props.buttonSize}
      />
    </Tooltip>
  );
}
